import type { ChipTone } from '../components/common/Chip'

// Das Vokabular des Depots an einer Stelle — dieselbe Regel wie bei den
// Handelsideen: Die Datenbank spricht englische Konstanten, die Oberfläche
// deutsch. Die Seiten BUY und SELL stehen in tradeIdeaVocabulary.ts und
// werden von dort genommen.

/** Wo eine Order steht. */
export const ORDER_STATUS: Record<string, string> = {
  OPEN: 'offen',
  CANCELLED: 'storniert',
  FILLED: 'ausgeführt',
  EXPIRED: 'abgelaufen',
}

export const ORDER_STATUS_HELP: Record<string, string> = {
  OPEN: 'In Auftrag gegeben. Eine Kauforder bindet Geld, eine Verkaufsorder Stücke.',
  CANCELLED: 'Storniert, mit Grund. Bindet nichts mehr.',
  FILLED: 'Ausgeführt — genau eine Transaktion gehört dazu. Zurücknehmen geht an der Order.',
  EXPIRED: 'Das Datum „gültig bis" ist vorbei. Wird beim Lesen gesetzt, nicht nachts.',
}

export function orderTone(status: string): ChipTone {
  if (status === 'OPEN') return 'info'
  if (status === 'FILLED') return 'good'
  if (status === 'CANCELLED') return 'neutral'
  if (status === 'EXPIRED') return 'warn'
  return 'neutral'
}
